// extracted by mini-css-extract-plugin
export default {"faq":"hKJBsN-","title":"lzLhm15","columns":"FJAJJue","split-columns":"BYcAJVu","splitColumns":"BYcAJVu","col":"OhEEUam"};